import { IState } from "store/index";
import { extractCurrentPermissions } from "utils/authUtils";

export const userIdSelector = (state: IState) => state.app.auth.id;
export const permissionsSelector = (state: IState) => extractCurrentPermissions(state.app)
export const isLoadingSelector = (state: IState) => state.app.auth.isLoading;
export const errorSelector = (state: IState) => state.app.auth.error;
